"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlanByPeople = exports.getPlanFromNameAndPeople = exports.appSumoPlans = exports.activePlans = exports.paypalPlans = exports.creativeJourneysPlans = exports.defaultPremiumPlan = exports.defaultGrowthPlan = exports.minEmailsForOverages = exports.pricePerExtraEmailInCents = exports.premiumEmailsPerSubscriberPerMonth = exports.growthEmailsPerSubscriberPerMonth = void 0;
const _ = require("lodash");
const api_exceptions_1 = require("../exceptions/api_exceptions");
exports.growthEmailsPerSubscriberPerMonth = 10;
exports.premiumEmailsPerSubscriberPerMonth = 12;
// $1k per 1M
exports.pricePerExtraEmailInCents = 0.1; // cents
exports.minEmailsForOverages = 1000;
const levelsV4 = [
    {
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
    },
    {
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
    },
    {
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
    },
    {
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
    },
    {
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
    },
    {
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
    },
    {
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
    },
    {
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
    },
    {
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
    },
    {
        peopleLowerLimit: 50001,
        peopleUpperLimit: 70000,
    },
    {
        peopleLowerLimit: 70001,
        peopleUpperLimit: 100000,
    },
    {
        peopleLowerLimit: 100001,
        peopleUpperLimit: 150000,
    },
    {
        peopleLowerLimit: 150001,
        peopleUpperLimit: 200000,
    },
    {
        peopleLowerLimit: 200001,
        peopleUpperLimit: 250000,
    },
    {
        peopleLowerLimit: 250001,
        peopleUpperLimit: 300000,
    },
    {
        peopleLowerLimit: 300001,
        peopleUpperLimit: 400000,
    },
    {
        peopleLowerLimit: 400001,
        peopleUpperLimit: 500000,
    },
    {
        peopleLowerLimit: 500001,
        peopleUpperLimit: 600000,
    },
    {
        peopleLowerLimit: 600001,
        peopleUpperLimit: 700000,
    },
    {
        peopleLowerLimit: 700001,
        peopleUpperLimit: 800000,
    },
    {
        peopleLowerLimit: 800001,
        peopleUpperLimit: 900000,
    },
    {
        peopleLowerLimit: 900001,
        peopleUpperLimit: 1000000,
    },
];
const levelsV5 = [
    {
        peopleLowerLimit: 0,
        peopleUpperLimit: 500,
    },
    {
        peopleLowerLimit: 501,
        peopleUpperLimit: 1000,
    },
    {
        peopleLowerLimit: 1001,
        peopleUpperLimit: 2000,
    },
    {
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
    },
    {
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
    },
    {
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
    },
    {
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
    },
    {
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
    },
    {
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
    },
    {
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
    },
    {
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
    },
    {
        peopleLowerLimit: 50001,
        peopleUpperLimit: 70000,
    },
    {
        peopleLowerLimit: 70001,
        peopleUpperLimit: 100000,
    },
    {
        peopleLowerLimit: 100001,
        peopleUpperLimit: 150000,
    },
    {
        peopleLowerLimit: 150001,
        peopleUpperLimit: 200000,
    },
    {
        peopleLowerLimit: 200001,
        peopleUpperLimit: 250000,
    },
    {
        peopleLowerLimit: 250001,
        peopleUpperLimit: 300000,
    },
    {
        peopleLowerLimit: 300001,
        peopleUpperLimit: 400000,
    },
    {
        peopleLowerLimit: 400001,
        peopleUpperLimit: 500000,
    },
    {
        peopleLowerLimit: 500001,
        peopleUpperLimit: 600000,
    },
    {
        peopleLowerLimit: 600001,
        peopleUpperLimit: 700000,
    },
    {
        peopleLowerLimit: 700001,
        peopleUpperLimit: 800000,
    },
    {
        peopleLowerLimit: 800001,
        peopleUpperLimit: 900000,
    },
    {
        peopleLowerLimit: 900001,
        peopleUpperLimit: 1500000,
    },
];
const duzerGroupLevels = [
    {
        peopleLowerLimit: 0,
        peopleUpperLimit: 80000,
    },
    {
        peopleLowerLimit: 80001,
        peopleUpperLimit: 90000,
    },
    {
        peopleLowerLimit: 90001,
        peopleUpperLimit: 100000,
    },
    {
        peopleLowerLimit: 100001,
        peopleUpperLimit: 110000,
    },
    {
        peopleLowerLimit: 110001,
        peopleUpperLimit: 120000,
    },
    {
        peopleLowerLimit: 120001,
        peopleUpperLimit: 130000,
    },
    {
        peopleLowerLimit: 130001,
        peopleUpperLimit: 140000,
    },
    {
        peopleLowerLimit: 140001,
        peopleUpperLimit: 150000,
    },
    {
        peopleLowerLimit: 150001,
        peopleUpperLimit: 160000,
    },
    {
        peopleLowerLimit: 160001,
        peopleUpperLimit: 170000,
    },
    {
        peopleLowerLimit: 170001,
        peopleUpperLimit: 180000,
    },
    {
        peopleLowerLimit: 180001,
        peopleUpperLimit: 190000,
    },
    {
        peopleLowerLimit: 190001,
        peopleUpperLimit: 200000,
    },
    {
        peopleLowerLimit: 200001,
        peopleUpperLimit: 1000000,
    },
];
const levelsEnterpriseV1 = [
    {
        peopleLowerLimit: 0,
        peopleUpperLimit: 150000,
    },
    {
        peopleLowerLimit: 150001,
        peopleUpperLimit: 200000,
    },
    {
        peopleLowerLimit: 200001,
        peopleUpperLimit: 250000,
    },
    {
        peopleLowerLimit: 250001,
        peopleUpperLimit: 300000,
    },
    {
        peopleLowerLimit: 300001,
        peopleUpperLimit: 350000,
    },
    {
        peopleLowerLimit: 350001,
        peopleUpperLimit: 400000,
    },
    {
        peopleLowerLimit: 400001,
        peopleUpperLimit: 450000,
    },
];
/**
 * Generate a family of plans by levels and corresponding prices
 */
const getPlanFamily = ({ name, humanName, tier, prices, period, levels, includeAccountIds, excludeAccountIds, }) => {
    return _.reduce(prices, (acc, price, index) => {
        const level = levels[index];
        if (!level) {
            return acc;
        }
        const plan = {
            name,
            humanName,
            tier,
            price,
            peopleLowerLimit: level.peopleLowerLimit,
            peopleUpperLimit: level.peopleUpperLimit,
            period,
            includeAccountIds,
            excludeAccountIds,
        };
        acc.push(plan);
        return acc;
    }, []);
};
exports.defaultGrowthPlan = "encharge-growth-monthly-v4";
exports.defaultPremiumPlan = "encharge-premium-monthly-v4";
const growthTierMonthlyPrices = [
    99, 179, 249, 299, 349, 389, 449, 499, 550, 770, 1100, 1650, 2200, 2750, 3300,
    4400, 5500, 6600, 7700, 8800, 9900, 11000,
];
const chargebeeGrowthPlans = [
    ...getPlanFamily({
        name: "encharge-growth-monthly-v4",
        humanName: "Encharge Growth (Monthly)",
        tier: "growth",
        prices: growthTierMonthlyPrices,
        levels: levelsV4,
        period: "month",
        excludeAccountIds: ["141549"],
    }),
    ...getPlanFamily({
        name: "encharge-growth-annual-v4",
        humanName: "Encharge Growth (Annual)",
        tier: "growth",
        prices: [
            948, 1668, 2388, 2868, 3348, 3708, 4308, 4788, 5268, 7392, 10560, 15840,
            21120, 26400, 31680, 42240, 52800, 63360, 73920, 84480, 95040, 105600,
        ],
        levels: levelsV4,
        period: "year",
        excludeAccountIds: ["141549"],
    }),
    ...getPlanFamily({
        name: "encharge-growth-duzer-group-yearly-v4",
        humanName: "Encharge Growth Duzer Group (Yearly)",
        tier: "growth",
        prices: [
            11520, 12960, 14400, 15840, 17280, 18720, 20160, 21600, 23040, 24480,
            25920, 27360, 28800, 30240,
        ],
        levels: duzerGroupLevels,
        period: "year",
    }),
    ...getPlanFamily({
        name: "encharge-growth-yearly-extra",
        humanName: "Encharge Growth (Yearly) Extra",
        tier: "growth",
        prices: [
            240, 470, 950, 1718, 2390, 2870, 3350, 3734, 4310, 4790, 5280, 7392,
            10560, 15840, 21120, 26400, 31680, 42240, 52800, 63360, 73920, 84480,
            95040, 105600,
        ],
        levels: levelsV5,
        period: "year",
        includeAccountIds: ["141549"],
    }),
];
const chargebeePremiumPlans = [
    ...getPlanFamily({
        name: "encharge-premium-monthly-v4",
        humanName: "Encharge Premium (Monthly)",
        tier: "premium",
        prices: [
            159, 269, 399, 489, 569, 649, 749, 809, 879, 1229, 1755, 2633, 3510, 4388,
            5265, 7020, 8775, 10530, 12285, 14040, 15795, 17550,
        ],
        levels: levelsV4,
        period: "month",
    }),
    ...getPlanFamily({
        name: "encharge-premium-annual-v4",
        humanName: "Encharge Premium (Annual)",
        tier: "premium",
        prices: [
            1548, 2628, 3828, 4668, 5388, 6228, 7068, 7788, 8388, 11794, 16848, 25272,
            33696, 42120, 50544, 67392, 84240, 101088, 117936, 134784, 151632, 168480,
        ],
        levels: levelsV4,
        period: "year",
    }),
];
const chargebeeEnterprisePlans = [
    ...getPlanFamily({
        name: "enterprise-premium-monthly-v1",
        humanName: "Encharge Enterprise (Monthly)",
        tier: "premium",
        prices: [1999, 2699, 3299, 3799, 4299, 4799, 5699],
        levels: levelsEnterpriseV1,
        period: "month",
    }).map((plan) => (Object.assign(Object.assign({}, plan), { isEnterprise: true }))),
    ...getPlanFamily({
        name: "enterprise-premium-monthly-netdata",
        humanName: "Encharge Enterprise (Monthly)",
        tier: "premium",
        prices: [1599, 1699, 2199, 2699, 3199, 3699, 4199],
        levels: levelsEnterpriseV1,
        period: "month",
    }).map((plan) => (Object.assign(Object.assign({}, plan), { isEnterprise: true }))),
    ...getPlanFamily({
        name: "copy_of_encharge-premium-monthly-v4",
        humanName: "Encharge Enterprise (Quarterly)",
        tier: "premium",
        prices: [0],
        levels: [
            {
                peopleLowerLimit: 0,
                peopleUpperLimit: 1000000,
            },
        ],
        period: "month",
    }).map((plan) => (Object.assign(Object.assign({}, plan), { isEnterprise: true }))),
];
exports.creativeJourneysPlans = [
    ...getPlanFamily({
        name: "encharge-growth-monthly-creativejourneysv1",
        humanName: "Encharge Growth (Monthly)",
        tier: "growth",
        prices: [25, 49, ...growthTierMonthlyPrices],
        levels: [
            {
                peopleLowerLimit: 0,
                peopleUpperLimit: 500,
            },
            {
                peopleLowerLimit: 501,
                peopleUpperLimit: 1000,
            },
            {
                peopleLowerLimit: 1001,
                peopleUpperLimit: 2000,
            },
            // omit the first plan of levelsV4, as we already have 1000-2000 plan
            ...levelsV4.slice(1),
        ],
        period: "month",
        includeAccountIds: ["141549"],
    }),
];
// Grandfathered pricing for growth
const chargebeeGrandfatheredPlans = [
    // Chargebee Growth Monthly
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        period: "month",
        price: 49,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        period: "month",
        price: 99,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        period: "month",
        price: 179,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        period: "month",
        price: 249,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        period: "month",
        price: 299,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
        period: "month",
        price: 349,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
        period: "month",
        price: 389,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
        period: "month",
        price: 449,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
        period: "month",
        price: 499,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 50001,
        peopleUpperLimit: 70000,
        period: "month",
        price: 599,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 70001,
        peopleUpperLimit: 100000,
        period: "month",
        price: 799,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v1",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 100001,
        peopleUpperLimit: 130000,
        period: "month",
        price: 999,
        tier: "growth",
    },
    // Premium monthly v2
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        period: "month",
        price: 49,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        period: "month",
        price: 99,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        period: "month",
        price: 179,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        period: "month",
        price: 249,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        period: "month",
        price: 299,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
        period: "month",
        price: 349,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
        period: "month",
        price: 389,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
        period: "month",
        price: 449,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v2",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
        period: "month",
        price: 499,
        tier: "premium",
    },
    // Premium monthly v3
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        period: "month",
        price: 59,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        period: "month",
        price: 119,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        period: "month",
        price: 199,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        period: "month",
        price: 299,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        period: "month",
        price: 359,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
        period: "month",
        price: 419,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
        period: "month",
        price: 479,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
        period: "month",
        price: 549,
        tier: "premium",
    },
    {
        name: "encharge-premium-monthly-v3",
        humanName: "Encharge Premium (Monthly)",
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
        period: "month",
        price: 599,
        tier: "premium",
    },
    // Premium Annual v3
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        period: "year",
        price: 588,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        period: "year",
        price: 1188,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        period: "year",
        price: 1988,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        period: "year",
        price: 2988,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        period: "year",
        price: 3588,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
        period: "year",
        price: 4188,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
        period: "year",
        price: 4788,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
        period: "year",
        price: 5488,
        tier: "premium",
    },
    {
        name: "encharge-premium-annual-v3",
        humanName: "Encharge Premium (Annual)",
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
        period: "year",
        price: 5988,
        tier: "premium",
    },
    // Growth Annual v1 (Grandfathered)
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        period: "year",
        price: 488,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        period: "year",
        price: 988,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        period: "year",
        price: 1788,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        period: "year",
        price: 2488,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        period: "year",
        price: 2988,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
        period: "year",
        price: 3488,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
        period: "year",
        price: 3888,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
        period: "year",
        price: 4488,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
        period: "year",
        price: 4988,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 50001,
        peopleUpperLimit: 70000,
        period: "year",
        price: 5988,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 70001,
        peopleUpperLimit: 100000,
        period: "year",
        price: 7988,
        tier: "growth",
    },
    {
        name: "encharge-growth-annual-v1",
        humanName: "Encharge Growth (Annual)",
        peopleLowerLimit: 100001,
        peopleUpperLimit: 130000,
        period: "year",
        price: 9988,
        tier: "growth",
    },
];
const appSumoDiscountedGrowthPlansV4 = [
    ...getPlanFamily({
        name: "encharge-growth-monthly-v4-appsumo",
        humanName: "Encharge Growth (Monthly)",
        tier: "growth",
        // prices from growth tier, reduced by 50%, only up to 200k people (first 13 levels)
        prices: _.map(growthTierMonthlyPrices, (price) => price * 0.5).slice(0, 13),
        levels: levelsV4,
        period: "month",
    }),
];
// Appsumo discounted plans - growth monthly only
// V2 Grandfathered is for existing large appsumo customers
const appSumoDiscountedGrowthPlansV2Grandfathered = [
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        period: "month",
        price: 25.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        period: "month",
        price: 49.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        period: "month",
        price: 89.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        period: "month",
        price: 124.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        period: "month",
        price: 149.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 20001,
        peopleUpperLimit: 25000,
        period: "month",
        price: 174.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 25001,
        peopleUpperLimit: 30000,
        period: "month",
        price: 194.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 30001,
        peopleUpperLimit: 40000,
        period: "month",
        price: 224.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 40001,
        peopleUpperLimit: 50000,
        period: "month",
        price: 249.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 50001,
        peopleUpperLimit: 70000,
        period: "month",
        price: 299.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 70001,
        peopleUpperLimit: 100000,
        period: "month",
        price: 399.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 100001,
        peopleUpperLimit: 130000,
        period: "month",
        price: 499.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 130001,
        peopleUpperLimit: 160000,
        period: "month",
        price: 599.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 160001,
        peopleUpperLimit: 200000,
        period: "month",
        price: 699.5,
        tier: "growth",
    },
    {
        name: "encharge-growth-monthly-v2-appsumo",
        humanName: "Encharge Growth (Monthly)",
        peopleLowerLimit: 200001,
        peopleUpperLimit: 240000,
        period: "month",
        price: 799.5,
        tier: "growth",
    },
];
// V3 Grandfathered Appsumo discounted plans for small existing customers
const appsumoV3GrandfatheredPrices = [
    // for grandfathered appsumo, we keep the current prices until 50k
    25.5, 49.5, 89.5, 124.5, 149.5, 174.5, 194.5, 224.5, 249.5,
    // and new prices for over 50k to 200k
    385, 550, 825, 1100,
];
const appSumoDiscountedGrowthPlansV3Grandfathered = getPlanFamily({
    name: "encharge-growth-monthly-v3-appsumo",
    humanName: "Encharge Growth (Monthly)",
    tier: "growth",
    prices: appsumoV3GrandfatheredPrices,
    levels: levelsV4,
    period: "month",
});
const depreciatedPaypalPlans = [
    {
        name: "y0-1000",
        humanName: "Encharge Premium (Annual)",
        price: 96,
        period: "year",
        peopleLowerLimit: 0,
        peopleUpperLimit: 1000,
        tier: "premium",
    },
    {
        name: "y1001-2000",
        humanName: "Encharge Premium (Annual)",
        price: 179,
        period: "year",
        peopleLowerLimit: 1001,
        peopleUpperLimit: 2000,
        tier: "premium",
    },
    {
        name: "m0-1000",
        humanName: "Encharge Premium (Monthly)",
        price: 16,
        period: "month",
        peopleLowerLimit: 0,
        peopleUpperLimit: 1000,
        tier: "premium",
    },
];
exports.paypalPlans = [
    {
        name: "0-5000",
        humanName: "Encharge Premium (Lifetime)",
        price: 79,
        period: "lifetime",
        peopleLowerLimit: 0,
        peopleUpperLimit: 5000,
        tier: "premium",
    },
    {
        name: "0-2000",
        humanName: "Encharge Premium (Lifetime)",
        price: 79,
        period: "lifetime",
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        tier: "premium",
    },
    // paypal monthly plans
    {
        name: "m0-2000",
        humanName: "Encharge Premium (Monthly)",
        period: "month",
        price: 49,
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        tier: "premium",
    },
    {
        name: "m2001-5000",
        humanName: "Encharge Premium (Monthly)",
        price: 99,
        period: "month",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        tier: "premium",
    },
    {
        name: "m5001-10000",
        humanName: "Encharge Premium (Monthly)",
        price: 179,
        period: "month",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        tier: "premium",
    },
    {
        name: "m10001-15000",
        humanName: "Encharge Premium (Monthly)",
        price: 249,
        period: "month",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        tier: "premium",
    },
    {
        name: "m15001-20000",
        humanName: "Encharge Premium (Monthly)",
        price: 299,
        period: "month",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        tier: "premium",
    },
    // paypal yearly plans
    {
        name: "y0-2000",
        humanName: "Encharge Premium (Annual)",
        period: "year",
        price: 468,
        peopleLowerLimit: 0,
        peopleUpperLimit: 2000,
        tier: "premium",
    },
    {
        name: "y2001-5000",
        humanName: "Encharge Premium (Annual)",
        price: 948,
        period: "year",
        peopleLowerLimit: 2001,
        peopleUpperLimit: 5000,
        tier: "premium",
    },
    {
        name: "y5001-10000",
        humanName: "Encharge Premium (Annual)",
        price: 1668,
        period: "year",
        peopleLowerLimit: 5001,
        peopleUpperLimit: 10000,
        tier: "premium",
    },
    {
        name: "y10001-15000",
        humanName: "Encharge Premium (Annual)",
        price: 2388,
        period: "year",
        peopleLowerLimit: 10001,
        peopleUpperLimit: 15000,
        tier: "premium",
    },
    {
        name: "y15001-20000",
        humanName: "Encharge Premium (Annual)",
        price: 2868,
        period: "year",
        peopleLowerLimit: 15001,
        peopleUpperLimit: 20000,
        tier: "premium",
    },
];
exports.activePlans = [
    ...chargebeeGrowthPlans,
    ...chargebeePremiumPlans,
    ...exports.creativeJourneysPlans,
];
const paymentPlans = [
    ...exports.activePlans,
    ...chargebeeEnterprisePlans,
    ...chargebeeGrandfatheredPlans,
    ...exports.creativeJourneysPlans,
    // lifetime plans
    ...exports.paypalPlans,
    // old paypal plans
    ...depreciatedPaypalPlans,
    ...appSumoDiscountedGrowthPlansV2Grandfathered,
    ...appSumoDiscountedGrowthPlansV3Grandfathered,
    ...appSumoDiscountedGrowthPlansV4,
];
exports.appSumoPlans = [
    ...chargebeePremiumPlans,
    ...appSumoDiscountedGrowthPlansV4,
];
// Nothing for now
const formatPlanName = (planName) => planName;
const getPlanFromNameAndPeople = ({ name, peopleUpperLimit, }) => {
    // remote "-trial" from name, as its the same plan with trial applied
    if (name.includes("-trial")) {
        // eslint-disable-next-line no-param-reassign
        name = name.replace("-trial", "");
    }
    const plan = _.find(paymentPlans, (current) => formatPlanName(current.name) === formatPlanName(name) &&
        current.peopleUpperLimit === peopleUpperLimit);
    if (!plan) {
        throw new api_exceptions_1.InternalException(`Unknown plan: ${name} for number of people: ${peopleUpperLimit}`);
    }
    return plan;
};
exports.getPlanFromNameAndPeople = getPlanFromNameAndPeople;
const getPlanByPeople = ({ name, people, }) => {
    const sameNamePlans = _.filter(paymentPlans, (plan) => formatPlanName(plan.name) === formatPlanName(name));
    const plan = _.reduce(sameNamePlans, (acc, current) => {
        if (current.peopleLowerLimit <= people &&
            people <= current.peopleUpperLimit) {
            return current;
        }
        return acc;
    }, undefined);
    return plan;
};
exports.getPlanByPeople = getPlanByPeople;
//# sourceMappingURL=plans.js.map